import React from "react";

import { Cartesian } from "@examspark/types";

import Toolbar from "../toolbar/Toolbar";

import * as Icons from "./icons";

interface Props {
  mode?: string;
  onChange: (mode?: string) => void;
}

const buttons: {
  type: Cartesian.ShapeType;
  label: string;
  component: React.ReactNode;
}[] = [
  {
    type: "point",
    label: "Point",
    component: <Icons.Point />,
  },
  {
    type: "line-segment",
    label: "Line Segment",
    component: <Icons.LineSegment width={16} />,
  },
  {
    type: "line-segment-right-open",
    label: "Line Segment",
    component: <Icons.LineSegmentRightOpen width={16} />,
  },
  {
    type: "line-segment-both-open",
    label: "Line Segment",
    component: <Icons.LineSegmentBothOpen width={16} />,
  },
  {
    type: "line-segment-left-open",
    label: "Line Segment",
    component: <Icons.LineSegmentLeftOpen width={16} />,
  },
  {
    type: "ray-left",
    label: "Line Segment",
    component: <Icons.RayLeft width={16} />,
  },
  {
    type: "ray-left-open",
    label: "Line Segment",
    component: <Icons.RayLeftOpen width={16} />,
  },
  {
    type: "ray-right-open",
    label: "Line Segment",
    component: <Icons.RayRightOpen width={16} />,
  },
  {
    type: "ray-right",
    label: "Line Segment",
    component: <Icons.RayRight width={16} />,
  },
];

const NumberLineToolbar: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <Toolbar>
      {buttons.map((b) => {
        return (
          <Toolbar.Button
            key={b.type}
            tooltip={b.label}
            data-cy={b.type}
            isPressed={props.mode === b.type}
            onClick={() => {
              if (props.mode === b.type) {
                props.onChange(undefined);
              } else {
                props.onChange(b.type);
              }
            }}
          >
            {b.component}
          </Toolbar.Button>
        );
      })}
      <Toolbar.Button
        tooltip="Erase"
        data-cy="erase"
        isPressed={props.mode === "erase"}
        onClick={() => {
          if (props.mode === "erase") {
            props.onChange(undefined);
          } else {
            props.onChange("erase");
          }
        }}
      >
        <svg viewBox="0 0 421.542 421.542" width="16">
          <path
            id="path1155"
            d="m106.584 61.396c-24.196 0-46.346 13.775-57.167 35.417l-42.667 85.375c-9 18.001-9 39.166 0 57.167l42.667 85.333c10.821 21.642 32.97 35.458 57.167 35.458h251.042c35.094 0 63.917-28.99 63.917-64.083v-170.709c0-35.094-28.823-63.958-63.917-63.958zm122.833 85.042c5.785.044 11.303 2.435 15.292 6.625l27.542 27.5 27.542-27.5c3.864-3.977 9.124-6.293 14.667-6.458 11.778-.346 21.607 8.921 21.953 20.699.175 5.937-2.134 11.678-6.37 15.842l-27.583 27.583 27.583 27.5c8.353 8.353 8.353 21.897 0 30.25s-21.897 8.353-30.25 0l-27.542-27.542-27.542 27.542c-8.353 8.353-21.897 8.353-30.25 0s-8.353-21.897 0-30.25l27.583-27.5-27.583-27.583c-8.491-8.17-8.75-21.677-.58-30.167 4.062-4.221 9.68-6.586 15.538-6.541z"
          />
        </svg>
      </Toolbar.Button>
    </Toolbar>
  );
};

export default NumberLineToolbar;
